<template>
  <v-card
    flat
    tile
    height="80px"
  >
    <v-toolbar dense>
      <!--<v-avatar><img src="/favicon.ico" style="width:25px; height: 25px;"/></v-avatar>-->

      <v-toolbar-title>Open Innovation <strong>{{pid}}</strong></v-toolbar-title>

      <v-spacer></v-spacer>

      <!--<v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>-->
      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-on:click="goIndex()"
          v-bind="attrs"
          v-on="on">
          <v-icon>mdi-login</v-icon>
        </v-btn>
      </template>
      <span>Cambiar usuario</span>
      </v-tooltip>
      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
      <v-btn icon @click.native="$router.go()"
          v-bind="attrs"
          v-on="on">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      </template>
      <span>Refrescar</span>
      </v-tooltip>
    </v-toolbar>
  </v-card>
</template>


<script>
import router from '@/router/index.js'
  export default {
    name: 'Header',
    props: ['pid'],
    methods: {
      async goIndex() {
        router.push({ name: "Index" });
      },   
    }
  }

  
</script>